<div class="d-flex justify-content-center">
  <div class="d-flex flex-wrap tile-align">
    <div class="wrapper">
      @for (tile of tiles; track tile) {
        <div>
          <div role="button" tabindex="0" (click)="onTileClick(tile)"
            (keydown.enter)="onTileClick(tile)" (keydown.space)="onTileClick(tile)">
            <div class="d-flex justify-content-center">
              <div class="d-flex justify-content-center align-items-center tile" [style.background-color]="tile.color">
                <img [src]="tile.image" class="tile-img" [alt]="tile.title" />
              </div>
            </div>
            <span class="tile-label">{{tile.title}}</span>
          </div>
        </div>
      }
    </div>
  </div>
</div>

<app-create-cast-member-modal></app-create-cast-member-modal>
<app-create-character-modal></app-create-character-modal>